/**
 * GA4 mínimo (initialize + page_view por ruta SPA).
 * Sin paquete `react-ga4` npm: la v3 es ESM puro incompatible con CRA 3 / webpack 4.
 */

export function getGaMeasurementId() {
    let raw = '';
    if (typeof process !== 'undefined' && process.env && process.env.REACT_APP_GA_MEASUREMENT_ID) {
        raw = `${process.env.REACT_APP_GA_MEASUREMENT_ID}`;
    }
    if (
        !raw.trim() &&
        typeof window !== 'undefined' &&
        window._env_ &&
        window._env_.REACT_APP_GA_MEASUREMENT_ID
    ) {
        raw = `${window._env_.REACT_APP_GA_MEASUREMENT_ID}`;
    }
    return raw.trim().replace(/^['"]+|['"]+$/g, '');
}

let initialized = false;

function ensureGtagStub() {
    if (typeof window === 'undefined') {
        return;
    }
    window.dataLayer = window.dataLayer || [];
    if (typeof window.gtag !== 'function') {
        window.gtag = function gtag() {
            window.dataLayer.push(arguments);
        };
    }
}

function loadGtagScript(measurementId) {
    if (typeof document === 'undefined') {
        return;
    }
    const exists = document.querySelector(
        'script[src*="googletagmanager.com/gtag/js"]',
    );
    if (exists) {
        return;
    }
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(
        measurementId,
    )}`;
    script.onerror = () => {
        if (typeof process !== 'undefined' && process.env.NODE_ENV !== 'production') {
            // eslint-disable-next-line no-console
            console.warn(
                '[GA] No se pudo cargar gtag desde googletagmanager.com (¿bloqueador, offline o CSP?).',
            );
        }
    };
    document.head.appendChild(script);
}

const ga = {
    initialize(measurementId) {
        if (!measurementId) {
            throw new Error('Require GA_MEASUREMENT_ID');
        }
        ensureGtagStub();
        loadGtagScript(measurementId);
        if (!initialized) {
            window.gtag('js', new Date());
            window.gtag('config', measurementId, { send_page_view: false });
            initialized = true;
        }
    },

    /** @param {{ hitType: string, page?: string }} fieldObject */
    send(fieldObject) {
        if (typeof window === 'undefined' || typeof window.gtag !== 'function') {
            return;
        }
        if (!fieldObject || fieldObject.hitType !== 'pageview') {
            return;
        }
        const page =
            fieldObject.page ||
            window.location.pathname + window.location.search;
        window.gtag('event', 'page_view', { page_path: page });
    },
};

export default ga;
